import React from 'react';

import { RATES_EMAIL_SUBMITTED_TEXT } from '../../../constants/Surveys';

import './EmailRatesSubmitted.css';

export const EmailRatesSubmitted = () => {
  return (
    <div className="email-rates-submitted-wrapper">
      <img
        src="https://res.cloudinary.com/amunoali/image/upload/v1739819143/Survey.png"
        className="rates-email-sent"
      />
      <div className="email-rates-submitted-text-wrapper">{RATES_EMAIL_SUBMITTED_TEXT}</div>
    </div>
  );
};
